// eslint-disable-next-line no-unused-vars
import React, { useRef, useState, useEffect } from "react";
import {
  Modal,
  Badge,
  PrimaryButton,
  TextButton,
  Alert,
} from "@artprov/design-system";
import { NuevaSolicitudForm } from "./NuevaSolicitudForm";
import {
  postValidarRecibo,
  postValidarReciboContraArca,
  sendAtachmentDetalleSolicitud as sendAtachmentDetalleSolicitudHttp,
} from "../../../services";
import { parseImporte } from "../../../utils/number.utils";

/**
   * @typedef {Object} NuevaSolicitudModalProps
   * @property {boolean} openModalFiltros - Indica si el modal está abierto.
   * @property {function} setOpenModalFiltros - Función para cambiar el estado del modal.
   * @property {Object} formFilter - Objeto que contiene los valores actuales de los filtros.
   * @property {function} setFormFilter - Función para actualizar el objeto de filtros.
   * @property {JSX.Element} chipsFiltrosModal - Chips que representan los filtros aplicados en el modal.
   * @property {boolean} cargando - Indica si los datos de tareas están cargándose.
   * @property {Array} tareas - Lista de tareas disponibles para el filtro.
   @property {function(Data): void} props.onSetNuevaSolicitud - Función para manejar y establecer una nueva solicitud.
   */

/**
 * Componente para mostrar el modal de filtros de "Nueva Solicitud".
 * @param {NuevaSolicitudModalProps} props
 */
export const NuevaSolicitudModal = ({
  openModalFiltros,
  setOpenModalFiltros,
  // TODO: todo lo que dice filter cambiarlo (este form no tiene nada que ver con filtros)
  datos,
  titulo,
  color,
  onSetNuevoComprobante = () => { },
}) => {
  const formRef = useRef(null);

  const [nuevoComprobante, setNuevoComprobante] = useState([])
  const [file, setFile] = useState({})
  const [disabledEnviar, setDisabledEnviar] = useState(true)
  const [error, setError] = useState([])
  const [iaAlert, setIaAlert] = useState(null)
  const [esNuevo, setEsNuevo] = useState(true)
  const [indice, setIndice] = useState(-1)
  const [arcaValidation, setArcaValidation] = useState(false);
  const [descripcionArcaValidation, setDescripcionArcaValidation] = useState('Ingresó un comprobante no válido por ARCA');
  const optionTipoAutorizacionArcaSinCae = 4;

  useEffect(() => {
    setEsNuevo(datos === false)
    setIndice(esNuevo ? -1 : datos.indice)
    setIaAlert(null)
  }, [openModalFiltros])

  useEffect(() => {
    if (Object.keys(file).length) {
      sendAtachmentDetalleSolicitud();
    }
  }, [file]);

  const completarComprobante = (nc) => {
    setDisabledEnviar(!nc.esValido);
    const comprobante = { ...nuevoComprobante, ...nc }
    comprobante.esNuevo = esNuevo
    comprobante.indice = indice
    setNuevoComprobante(comprobante)
  };

  const sendAtachmentDetalleSolicitud = async () => {
    const response = await sendAtachmentDetalleSolicitudHttp(file);
    const idArchivo = response.idArchivo;
    let comprobante = {
      ...nuevoComprobante,
      ...{ idfiles3: idArchivo },
      file: file,
    };
    setNuevoComprobante(comprobante);
  };

  const atachmentFileComprobante = async (data) => {
    setFile(data);
  };


  const handleAgregarButton = async () => {
    const { numeroFactura, cuit, comprobante, idTipoComprobante, tipoCaeCai } =
      nuevoComprobante;
    const [establecimiento, numero] = numeroFactura.split("-");

    try {

      if (comprobante !== "Otros comprobantes") {
        const { type } = await postValidarRecibo({
          cuit,
          establecimiento,
          numero,
          tipocomprobanteid: idTipoComprobante,
        });

        if (type) {
          setError([{ duplicidad: "El comprobante ya existe para la CUIT." }]);
          return;
        }
      }

    } catch (error) {
      if (error.status && error.status != 500) {
        setError([{ duplicidad: "El comprobante ya existe para la CUIT." }]);
        return;
      }

      setError([
        { duplicidad: "Error al comprobar los datos del comprobante." },
      ]);
      return;
    }

    if (
      comprobante !== "Otros comprobantes" &&
      optionTipoAutorizacionArcaSinCae != tipoCaeCai
    ) {
      //Existen comprobantes que pueden ir o no sin el nro de cae
      const { fecha, importe, caeCai } = nuevoComprobante;
      try {
        const payload = {
          tipocomprobanteid: idTipoComprobante,
          tipoautorizacionafipid: tipoCaeCai,
          cuit: cuit,
          establecimiento: establecimiento,
          numero: numero,
          fecha: fecha,
          importe: parseImporte(importe),
          cae: caeCai,
        };

        await postValidarReciboContraArca(payload);
        setArcaValidation(false);
      } catch (error) {
        if (error.status && error.status != 500) {
          const mensaje = obtenerIndiceError(error?.response?.data?.message ?? 'Error validacion : No se pudo validar el comprobante en ARCA')
          setDescripcionArcaValidation(mensaje)
          setArcaValidation(true);
          return;
        }
        setArcaValidation(true);
        return;
      }
    }

    if (!disabledEnviar) {
      onSetNuevoComprobante(nuevoComprobante);
      setOpenModalFiltros(false);
    }
  };
  return (
    <Modal.Container
      open={openModalFiltros}
      setOpen={setOpenModalFiltros}
      closeOnClickOutside={false}
      buttonRef={{}}
      onClose={() => setOpenModalFiltros(false)}>
      <Modal.Content height="726px" width="600px" className=" gap-0 pb-4">
        <Modal.Header className="flex flex-col items-start mb-[8px] px-5 -ml-[10px]">
          <div className="flex justify-between w-full items-start">
            <Modal.Title className="">{"Nuevo comprobante"}</Modal.Title>
            <Modal.Close onClose={() => setOpenModalFiltros(false)} />
          </div>

          <div className="mt-2 w-full flex justify-start">
            <Badge variant={color} className="border-l-[8px] pl-2 block">
              {titulo}
            </Badge>
          </div>
          {iaAlert && (
            <div className="sticky top-0 z-10 mt-4 w-full">
              <Alert
                variant={iaAlert.variant}
                title={iaAlert.title}
                description={iaAlert.description}
                titleStyle={iaAlert.titleStyle}
                descriptionStyle={iaAlert.descriptionStyle}
                icon={iaAlert.icon}
                iconStyle={iaAlert.iconStyle}
                interactive={true}
                onClose={() => setIaAlert(null)}
              />
            </div>
          )}
        </Modal.Header>
        <Modal.Body className="mb-[16px] overflow-hidden" classNameScrollContainer="mr-0">
          {arcaValidation && (
            <div className="mb-4">
              <Alert
                containerStyle="max-w-lg p-2"
                variant="error"
                title="Verificación de ARCA"
                description={<p className="max-w-lg break-normal">{descripcionArcaValidation?.includes(':') ? descripcionArcaValidation.split(':')[1] : descripcionArcaValidation}</p>}
                autoDismiss={false}
                onClose={() => setArcaValidation(false)}
              />
            </div>
          )}
          <div>
            <NuevaSolicitudForm
              datos={datos}
              ref={formRef}
              onCompletarComprobante={completarComprobante}
              onSetFile={atachmentFileComprobante}
              onSetIaAlert={setIaAlert}
              onClose={() => setOpenModalFiltros(false)}
              errorOnSubmit={error}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="flex justify-end pr-5">
          <div className="flex">
            <TextButton
              className="mx-2 relative -top-[1px]"
              size="small"
              onClick={() => {
                setOpenModalFiltros(false);
              }}>
              Cancelar
            </TextButton>
            <PrimaryButton
              className="mx-2"
              size="small"
              onClick={handleAgregarButton}
              classNameIcon="text-tertiary-100"
              disabled={disabledEnviar}>
              {!datos ? "Agregar" : "Editar"}
            </PrimaryButton>
          </div>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Container>
  );
};

function obtenerIndiceError(texto) {

  const errores = [
    "Comprobante inválido - Errores : El punto de venta consignado no se corresponde con el CAI/CAE/CAEA ingresado",
    "Comprobante inválido - Errores : El N° de comprobante no se corresponde con el CAI/CAE/CAEA ingresado",
    "Comprobante inválido - Errores : La cuit del emisor no se corresponde con el CAI/CAE/CAEA ingresado o no es válida y no se encontraba activa al momento de emisión de comprobante.",
    "Comprobante inválido - Errores : La fecha consignada no se corresponde con la registrada para el CAE/CAEA ingresado",
    "Comprobante inválido - Errores : El tipo de comprobante no se corresponde con el CAI/CAE/CAEA ingresado",
    "Comprobante inválido - Errores : El importe total no se corresponde con lo registrado en las bases de datos del organismo.",
    "Comprobante inválido - Errores : El N° de CAI/CAE/CAEA consultado no existe en las bases del organismo.",
    "Comprobante inválido - Errores : El N° de CAI/CAE/CAEA consultado no existe en las bases del organismo."
  ];


  const erroresFormateados = [
    "El Punto de venta no corresponde con el N° de código de autorización ingresado.",
    "El N° de comprobante no corresponde con el N° de código de autorización ingresado.",
    "La CUIT del emisor no corresponde con el N° de código de autorización ingresado o no es válida.",
    "La Fecha consignada no corresponde con la registrada para el N° de código de autorización ingresado.",
    "El Tipo de comprobante no corresponde con el N° de código de autorización ingresado.",
    "El Importe total no corresponde con lo registrado en la BD del organismo.",
    "El Código de autorización no corresponde al Número de código de Autorización ingresado.",
    "El N° de código de autorización consultado no existe en las bases del organismo." // este está duplicado en la imagen
  ];

  for (let i = 0; i < errores.length; i++) {
    if (texto.includes(errores[i])) {
      return erroresFormateados[i];
    }
  }

  return texto;
}